<template>
  <div>
    <v-container style="max-width: 1200px;">
      <ProjectPagesCard></ProjectPagesCard>
    </v-container>
  </div>
</template>

<script>
import ProjectPagesCard from "../../components/project/ProjectPagesCard";

export default {
  components: {
    ProjectPagesCard
  }
};
</script>